
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34800',
  depVersions: {
  "documents-public-ui": "static-1.34800",
  "atom": "static-1.5191",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2614",
  "client-types": "static-1.481",
  "cssUtils": "static-1.825",
  "customer-data-filters-ui": "static-1.40211",
  "customer-data-objects": "static-1.7794",
  "customer-data-property-utils": "static-1.8211",
  "documents-lib": "static-1.34805",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.346",
  "FormsCommonComponents": "static-1.86136",
  "FormUrlGenerator": "static-2.4838",
  "foundations-theming-specialty": "static-1.2264",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5709",
  "hs-test-utils": "static-1.8136",
  "hub-http": "static-1.6339",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11897",
  "HubStyleTokens": "static-2.11590",
  "I18n": "static-7.1639",
  "icons": "static-2.654",
  "jasmine-immutable": "static-1.3137",
  "jasmine-runner": "static-1.6574",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7269",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5513",
  "quartz": "static-1.7180",
  "react": "static-7.187",
  "react-dlb": "static-1.81",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16800",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5427",
  "react-virtualized": "static-2.100",
  "reference-resolvers": "static-1.8291",
  "reference-resolvers-lite": "static-1.8213",
  "reporting-data": "static-1.68053",
  "reporting-reports": "static-1.67731",
  "reporting-snowflake": "static-1.56671",
  "reporting-testing-lib": "static-1.9986",
  "reporting-visualizations": "static-1.60129",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.9063",
  "sanitize": "static-1.4592",
  "sanitize-text": "static-1.8261",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1860",
  "signup-constants": "static-1.19135",
  "signup-ui-url-generator": "static-2.8173",
  "StyleGuideUI": "static-3.489",
  "superstore": "static-1.4875",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4875",
  "ui-addon-form-validation": "static-1.11106",
  "ui-asset-management-lib": "static-1.11184",
  "ui-images": "static-2.1183",
  "UIComponents": "static-3.8536",
  "usage-tracker": "static-1.7465",
  "usage-tracker-container": "static-1.7455",
  "usage-tracker-core": "static-1.7315",
  "viral-links-lib": "static-1.7184",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9778",
  "foundations-components": "static-1.8170",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.958",
  "quartz-core": "static-1.6399",
  "quick-fetch": "static-1.4003",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4773",
  "ui-addon-i18n": "static-1.11265",
  "ui-addon-upgrades": "static-9.18155",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3485",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3457",
  "quartz-webpack": "static-1.3404",
  "foundations-assets": "static-1.4989",
  "foundations-theming": "static-1.4548",
  "hub-http-shared-msw-handlers": "static-1.10258",
  "hubspotter-http": "static-1.4736",
  "sassPrefix": "static-1.158",
  "conversations-skeleton-state": "static-1.7363",
  "crm-message-bus": "static-1.43294",
  "customer-data-filters-ui-msw-helpers": "static-1.22646",
  "customer-data-objects-ui-components": "static-1.13145",
  "customer-data-reference-ui-components": "static-1.13290",
  "customer-data-ui-utilities": "static-1.9941",
  "events-data-lib": "static-1.349",
  "framework-builder-read-service-client": "static-1.4089",
  "framework-data-schema-quick-fetch": "static-1.6914",
  "framework-data-schema-resolvers": "static-1.7009",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3672",
  "inbound-db-properties-service-client": "static-1.3932",
  "multi-account-reference-resolvers": "static-1.1098",
  "onboarding-tours": "static-1.16828",
  "reporting-datasets-permissions-lib": "static-1.14021",
  "ui-addon-teams": "static-1.21703",
  "quartz-auth": "static-1.855",
  "ui-business-units-lib": "static-1.9183",
  "usage-tracker-session-replay": "static-1.5151",
  "ai-components-ui-library": "static-1.9256",
  "ContentUtils": "static-1.68709",
  "customer-data-properties": "static-1.51974",
  "forms-ai-lib": "static-1.4507",
  "forms-utils-lib": "static-1.12808",
  "foundations-components-test-utils": "static-1.5653",
  "react-dnd-compat": "static-1.4731",
  "react-tinymce": "static-1.55559",
  "tinymce-config": "static-2.54685",
  "ui-gdpr-components": "static-1.10466",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3533",
  "HeadJS": "static-2.771",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3247",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.167",
  "ui-fonts": "static-1.852",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4442",
  "csstype": "static-1.50",
  "quartz-head": "static-1.845",
  "web-vitals": "static-1.7",
  "batch-promise": "static-1.1659",
  "external-options-client-types": "static-1.4212",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.855",
  "frontend-preferences-client": "static-1.8043",
  "graphql": "static-1.83",
  "persist-promise": "static-1.3816",
  "reporting-client-types": "static-1.2570",
  "apollo-stack-hubspot": "static-3.87",
  "growth-payments-core": "static-1.25727",
  "hubspot-apollo-client": "static-1.4994",
  "foundations-components-legacy": "static-1.1195",
  "quartz-routing": "static-1.610",
  "hs-story-utils": "static-1.9539",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.345",
  "timezone-utils": "static-2.5359",
  "seat-types-lib": "static-1.279",
  "react-create-root-preference": "static-1.37",
  "bend-plugin-foundations-components": "static-1.4439",
  "floating-ui": "static-1.58",
  "react-aria": "static-1.67",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2196",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.846",
  "mobile-manifest-mixins": "static-1.545",
  "module-federation": "static-1.27",
  "quartz-test": "static-1.855",
  "quartz-tracking": "static-1.559",
  "trellis-components": "static-1.2215",
  "bend-plugin-chirp-manifest": "static-1.183",
  "chirp-fetch": "static-1.2004",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6096",
  "salesImages": "static-1.527",
  "ts-schema": "static-1.4167",
  "bender-build-tools": "static-1.3297",
  "bend-plugin-foundations-theming": "static-1.3031",
  "stylex": "static-1.35",
  "restore-request-side-panel-lib": "static-1.1173",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.291",
  "pulse": "static-1.720",
  "conditional-properties-service-client": "static-1.3883",
  "crm-pipelines-api-client-types": "static-1.4222",
  "fdsr-migration-layer": "static-1.128",
  "multi-currency-client-types": "static-1.3776",
  "getting-started-shared-tasks": "static-1.18742",
  "growth-data-modal": "static-1.5623",
  "growth-onboarding-confetti": "static-1.3181",
  "growth-onboarding-next-action-utils": "static-1.2259",
  "navigation-components": "static-1.18303",
  "onboarding-tours-client": "static-1.5042",
  "onboarding-tours-utils": "static-1.894",
  "ui-shepherd-react": "static-3.10367",
  "ui-shepherd-tracker": "static-1.7748",
  "ui-universal-auth": "static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "user-context": "static-1.5225",
  "hubspotter-http-shared-msw-handlers": "static-1.10256",
  "magpie-lib": "static-1.5627",
  "navigation-messaging": "static-1.7630",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21853",
  "copilot-toolkit": "static-1.11437",
  "cms-field-types": "static-1.4931",
  "content-icons-ui": "static-1.2259",
  "integrations-lib": "static-1.16533",
  "calling-global-api": "static-1.64918",
  "calling-internal-common": "static-1.31426",
  "calling-lifecycle-internal": "static-1.66300",
  "calling-lifecycle-messages": "static-1.58594",
  "commerce-products-lib": "static-1.9999",
  "crm-links": "static-1.6424",
  "customer-data-properties-shared-msw-handlers": "static-1.9585",
  "file-manager-components": "static-1.23957",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4303",
  "meetings-icalendar-utils-lib": "static-1.749",
  "object-builder-ui-client": "static-1.49153",
  "pipeline-validation-client-types": "static-1.4051",
  "property-value-citations": "static-1.2588",
  "smart-property-lib": "static-1.7845",
  "tiered-pricing": "static-1.1527",
  "ui-addon-iframeable": "static-1.9183",
  "zustand": "static-1.74",
  "final-form": "static-1.71",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20041",
  "tinymce-themes": "static-1.56655",
  "data-token-picker": "static-1.16623",
  "hub-http-contrib": "static-1.3159",
  "interframe": "static-3.4876",
  "tinymce-data": "static-1.40770",
  "tinymce-plugins": "static-1.57799",
  "ui-addon-sales-email": "static-1.5326",
  "onboarding-scopes": "static-1.6576",
  "ui-addon-opt": "static-4.8477",
  "apollo-link-hub-http": "static-2.4767",
  "hubspot-apollo-cache": "static-1.453",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.289",
  "base-ui": "static-1.14",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1057",
  "tanstack-virtual": "static-1.31",
  "purchase-motions-api": "static-1.6099",
  "unified-auth-core-lib": "static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "event-emitter": "static-1.1065",
  "bend-plugin-pulse": "static-1.223",
  "fast-json-patch": "static-1.64",
  "onboarding-data-sync-lib": "static-1.2169",
  "growth-onboarding-next-action-components": "static-1.2287",
  "user-context-client": "static-1.4696",
  "idb-keyval": "static-1.45",
  "magpie-types": "static-1.5087",
  "nest": "static-1.348",
  "reactive-lib": "static-1.842",
  "simple-logging-lib": "static-1.3165",
  "getting-started-shared-tasks-store": "static-1.17860",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1129",
  "integrations-error-boundary-lib": "static-1.13948",
  "integrations-tracking-lib": "static-1.5722",
  "native-integrations-shared-strings": "static-1.7898",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10478",
  "rxjs": "static-5.10",
  "unified-auth": "static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "calling-error-reporting": "static-1.31433",
  "shared-worker-versioning": "static-1.11151",
  "calling-usage-tracker": "static-1.6659",
  "voice-sms-access-library": "static-1.1448",
  "customer-data-tracking": "static-1.7003",
  "commerce-permissions": "static-1.892",
  "products-iframe-lib": "static-1.8259",
  "products-ui-components-shared-msw-handlers": "static-1.10640",
  "location-customization-utils-lib": "static-1.9602",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4266",
  "video-components-external": "static-1.11659",
  "video-data-lib": "static-1.35317",
  "data-agent-kit": "static-1.396",
  "feedback-loader": "static-1.29524",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10341",
  "fsm": "static-1.3844",
  "policy-lib": "static-1.6898",
  "react-colorpicker": "static-2.10323",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10404",
  "FileManagerLib": "static-1.39597",
  "NamespacedHubStyle": "static-2.9139",
  "FileManagerCore": "static-1.39456",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7946",
  "layout-dnd-components": "static-1.12680",
  "layout-dnd-utils": "static-1.11655",
  "react-codemirror": "static-1.10743",
  "ui-addon-emoji-picker": "static-1.10003",
  "ui-brand-identity-lib": "static-1.15709",
  "adobe-sign-auth-lib": "static-1.23",
  "ads-unified-auth-lib": "static-1.394",
  "google-sheets-integration-lib": "static-1.588",
  "microsoft-drive-integration-lib": "static-1.726",
  "surveymonkey-integration-lib": "static-1.43",
  "slack-ui-library": "static-1.10512",
  "InboxConnectUtils": "static-4.15123",
  "meetings-connect-utils-lib": "static-1.7721",
  "breeze-engine-core": "static-1.407",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "universal-page-editor-lib": "static-1.3132",
  "calling-orchestration-schema": "static-1.36225",
  "sales-views-client-types": "static-1.4373",
  "crm-record-cards-service-types": "static-1.3671",
  "content-media-composition-data-lib": "static-1.12677",
  "content-media-compositions": "static-2.16684",
  "media-bridge-lib": "static-1.19136",
  "trellis-story-utils": "static-1.4627",
  "storybook-react": "static-1.34",
  "audio-components": "static-1.6102",
  "FileManagerImages": "static-1.37108",
  "video-components": "static-1.13661",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4652",
  "video-embed": "static-1.36151",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8820",
  "ui-coaching-tips": "static-1.28889",
  "ContentData": "static-1.68784",
  "layout-data-lib": "static-1.9980",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22351",
  "outpost": "static-1.4286",
  "growth-onboarding-feedback-components": "static-1.6694",
  "advanced-menus-core": "static-1.15329",
  "advanced-menus-lib": "static-1.12240",
  "ExportDialog": "static-6.10496",
  "ui-memberships-settings-lib": "static-1.34361",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15328",
  "simple-menus-lib": "static-1.16845"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34800",
  "atom": "/atom/static-1.5191",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2614",
  "client-types": "/client-types/static-1.481",
  "cssUtils": "/cssUtils/static-1.825",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40211",
  "customer-data-objects": "/customer-data-objects/static-1.7794",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8211",
  "documents-lib": "/documents-lib/static-1.34805",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.346",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86136",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4838",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2264",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5709",
  "hs-test-utils": "/hs-test-utils/static-1.8136",
  "hub-http": "/hub-http/static-1.6339",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11897",
  "HubStyleTokens": "/HubStyleTokens/static-2.11590",
  "I18n": "/I18n/static-7.1639",
  "icons": "/icons/static-2.654",
  "jasmine-immutable": "/jasmine-immutable/static-1.3137",
  "jasmine-runner": "/jasmine-runner/static-1.6574",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7269",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5513",
  "quartz": "/quartz/static-1.7180",
  "react": "/react/static-7.187",
  "react-dlb": "/react-dlb/static-1.81",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16800",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5427",
  "react-virtualized": "/react-virtualized/static-2.100",
  "reference-resolvers": "/reference-resolvers/static-1.8291",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8213",
  "reporting-data": "/reporting-data/static-1.68053",
  "reporting-reports": "/reporting-reports/static-1.67731",
  "reporting-snowflake": "/reporting-snowflake/static-1.56671",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9986",
  "reporting-visualizations": "/reporting-visualizations/static-1.60129",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9063",
  "sanitize": "/sanitize/static-1.4592",
  "sanitize-text": "/sanitize-text/static-1.8261",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1860",
  "signup-constants": "/signup-constants/static-1.19135",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8173",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "superstore": "/superstore/static-1.4875",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4875",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11106",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11184",
  "ui-images": "/ui-images/static-2.1183",
  "UIComponents": "/UIComponents/static-3.8536",
  "usage-tracker": "/usage-tracker/static-1.7465",
  "usage-tracker-container": "/usage-tracker-container/static-1.7455",
  "usage-tracker-core": "/usage-tracker-core/static-1.7315",
  "viral-links-lib": "/viral-links-lib/static-1.7184",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9778",
  "foundations-components": "/foundations-components/static-1.8170",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.958",
  "quartz-core": "/quartz-core/static-1.6399",
  "quick-fetch": "/quick-fetch/static-1.4003",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4773",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11265",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18155",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3485",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3457",
  "quartz-webpack": "/quartz-webpack/static-1.3404",
  "foundations-assets": "/foundations-assets/static-1.4989",
  "foundations-theming": "/foundations-theming/static-1.4548",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10258",
  "hubspotter-http": "/hubspotter-http/static-1.4736",
  "sassPrefix": "/sassPrefix/static-1.158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7363",
  "crm-message-bus": "/crm-message-bus/static-1.43294",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22646",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13145",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13290",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9941",
  "events-data-lib": "/events-data-lib/static-1.349",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4089",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6914",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7009",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3672",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3932",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1098",
  "onboarding-tours": "/onboarding-tours/static-1.16828",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14021",
  "ui-addon-teams": "/ui-addon-teams/static-1.21703",
  "quartz-auth": "/quartz-auth/static-1.855",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9183",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5151",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9256",
  "ContentUtils": "/ContentUtils/static-1.68709",
  "customer-data-properties": "/customer-data-properties/static-1.51974",
  "forms-ai-lib": "/forms-ai-lib/static-1.4507",
  "forms-utils-lib": "/forms-utils-lib/static-1.12808",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5653",
  "react-dnd-compat": "/react-dnd-compat/static-1.4731",
  "react-tinymce": "/react-tinymce/static-1.55559",
  "tinymce-config": "/tinymce-config/static-2.54685",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10466",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3533",
  "HeadJS": "/HeadJS/static-2.771",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3247",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.167",
  "ui-fonts": "/ui-fonts/static-1.852",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4442",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.845",
  "web-vitals": "/web-vitals/static-1.7",
  "batch-promise": "/batch-promise/static-1.1659",
  "external-options-client-types": "/external-options-client-types/static-1.4212",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.855",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8043",
  "graphql": "/graphql/static-1.83",
  "persist-promise": "/persist-promise/static-1.3816",
  "reporting-client-types": "/reporting-client-types/static-1.2570",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "growth-payments-core": "/growth-payments-core/static-1.25727",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4994",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1195",
  "quartz-routing": "/quartz-routing/static-1.610",
  "hs-story-utils": "/hs-story-utils/static-1.9539",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.345",
  "timezone-utils": "/timezone-utils/static-2.5359",
  "seat-types-lib": "/seat-types-lib/static-1.279",
  "react-create-root-preference": "/react-create-root-preference/static-1.37",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4439",
  "floating-ui": "/floating-ui/static-1.58",
  "react-aria": "/react-aria/static-1.67",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2196",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.846",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.545",
  "module-federation": "/module-federation/static-1.27",
  "quartz-test": "/quartz-test/static-1.855",
  "quartz-tracking": "/quartz-tracking/static-1.559",
  "trellis-components": "/trellis-components/static-1.2215",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.183",
  "chirp-fetch": "/chirp-fetch/static-1.2004",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6096",
  "salesImages": "/salesImages/static-1.527",
  "ts-schema": "/ts-schema/static-1.4167",
  "bender-build-tools": "/bender-build-tools/static-1.3297",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3031",
  "stylex": "/stylex/static-1.35",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1173",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.291",
  "pulse": "/pulse/static-1.720",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3883",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4222",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.128",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3776",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18742",
  "growth-data-modal": "/growth-data-modal/static-1.5623",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3181",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2259",
  "navigation-components": "/navigation-components/static-1.18303",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5042",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.894",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10367",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7748",
  "ui-universal-auth": "/ui-universal-auth/static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "user-context": "/user-context/static-1.5225",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10256",
  "magpie-lib": "/magpie-lib/static-1.5627",
  "navigation-messaging": "/navigation-messaging/static-1.7630",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21853",
  "copilot-toolkit": "/copilot-toolkit/static-1.11437",
  "cms-field-types": "/cms-field-types/static-1.4931",
  "content-icons-ui": "/content-icons-ui/static-1.2259",
  "integrations-lib": "/integrations-lib/static-1.16533",
  "calling-global-api": "/calling-global-api/static-1.64918",
  "calling-internal-common": "/calling-internal-common/static-1.31426",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66300",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58594",
  "commerce-products-lib": "/commerce-products-lib/static-1.9999",
  "crm-links": "/crm-links/static-1.6424",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9585",
  "file-manager-components": "/file-manager-components/static-1.23957",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4303",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.749",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49153",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4051",
  "property-value-citations": "/property-value-citations/static-1.2588",
  "smart-property-lib": "/smart-property-lib/static-1.7845",
  "tiered-pricing": "/tiered-pricing/static-1.1527",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9183",
  "zustand": "/zustand/static-1.74",
  "final-form": "/final-form/static-1.71",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20041",
  "tinymce-themes": "/tinymce-themes/static-1.56655",
  "data-token-picker": "/data-token-picker/static-1.16623",
  "hub-http-contrib": "/hub-http-contrib/static-1.3159",
  "interframe": "/interframe/static-3.4876",
  "tinymce-data": "/tinymce-data/static-1.40770",
  "tinymce-plugins": "/tinymce-plugins/static-1.57799",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5326",
  "onboarding-scopes": "/onboarding-scopes/static-1.6576",
  "ui-addon-opt": "/ui-addon-opt/static-4.8477",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4767",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.453",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.289",
  "base-ui": "/base-ui/static-1.14",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1057",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "purchase-motions-api": "/purchase-motions-api/static-1.6099",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "event-emitter": "/event-emitter/static-1.1065",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.223",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2169",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2287",
  "user-context-client": "/user-context-client/static-1.4696",
  "idb-keyval": "/idb-keyval/static-1.45",
  "magpie-types": "/magpie-types/static-1.5087",
  "nest": "/nest/static-1.348",
  "reactive-lib": "/reactive-lib/static-1.842",
  "simple-logging-lib": "/simple-logging-lib/static-1.3165",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17860",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1129",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13948",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5722",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7898",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10478",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "calling-error-reporting": "/calling-error-reporting/static-1.31433",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11151",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6659",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1448",
  "customer-data-tracking": "/customer-data-tracking/static-1.7003",
  "commerce-permissions": "/commerce-permissions/static-1.892",
  "products-iframe-lib": "/products-iframe-lib/static-1.8259",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10640",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9602",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4266",
  "video-components-external": "/video-components-external/static-1.11659",
  "video-data-lib": "/video-data-lib/static-1.35317",
  "data-agent-kit": "/data-agent-kit/static-1.396",
  "feedback-loader": "/feedback-loader/static-1.29524",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10341",
  "fsm": "/fsm/static-1.3844",
  "policy-lib": "/policy-lib/static-1.6898",
  "react-colorpicker": "/react-colorpicker/static-2.10323",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10404",
  "FileManagerLib": "/FileManagerLib/static-1.39597",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9139",
  "FileManagerCore": "/FileManagerCore/static-1.39456",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7946",
  "layout-dnd-components": "/layout-dnd-components/static-1.12680",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11655",
  "react-codemirror": "/react-codemirror/static-1.10743",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10003",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15709",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.23",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.394",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.588",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.726",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.43",
  "slack-ui-library": "/slack-ui-library/static-1.10512",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15123",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7721",
  "breeze-engine-core": "/breeze-engine-core/static-1.407",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3132",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36225",
  "sales-views-client-types": "/sales-views-client-types/static-1.4373",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3671",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12677",
  "content-media-compositions": "/content-media-compositions/static-2.16684",
  "media-bridge-lib": "/media-bridge-lib/static-1.19136",
  "trellis-story-utils": "/trellis-story-utils/static-1.4627",
  "storybook-react": "/storybook-react/static-1.34",
  "audio-components": "/audio-components/static-1.6102",
  "FileManagerImages": "/FileManagerImages/static-1.37108",
  "video-components": "/video-components/static-1.13661",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4652",
  "video-embed": "/video-embed/static-1.36151",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8820",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28889",
  "ContentData": "/ContentData/static-1.68784",
  "layout-data-lib": "/layout-data-lib/static-1.9980",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22351",
  "outpost": "/outpost/static-1.4286",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6694",
  "advanced-menus-core": "/advanced-menus-core/static-1.15329",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12240",
  "ExportDialog": "/ExportDialog/static-6.10496",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34361",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15328",
  "simple-menus-lib": "/simple-menus-lib/static-1.16845"
}
};
